import a from "react";
import { s as i } from "../../../style-inject.es-1f59c1d0.js";
import e from "../../../services/Tracking/Tracking.js";
import n from "../../../services/Images.js";
import t from "../../../services/Url.js";
import { g as s, $ as l, b as r, S as o, a as p } from "../../../swiper.min-fcb62bfb.js";
import "../../../_rollupPluginBabelHelpers-d2f9cf82.js";
import "../../../services/Tracking/FacebookPixel.js";
import "../../../services/Tracking/Pl.js";
import "../../../services/ApiRequests.js";
import "axios";
import "../../../services/Tracking/GoogleAnalitycs.js";
import "../../../services/Utils.js";
import "../../../services/Tracking/GoogleTagManager.js";
function g(a, i, e, n) {
  const t = s();
  return a.params.createElements && Object.keys(n).forEach(s => {
    if (!e[s] && !0 === e.auto) {
      let l = a.$el.children(`.${n[s]}`)[0];
      l || (l = t.createElement("div"), l.className = n[s], a.$el.append(l)), e[s] = l, i[s] = l;
    }
  }), e;
}
function c(a = "") {
  return `.${a.trim().replace(/([\.:!\/])/g, "\\$1").replace(/ /g, ".")}`;
}
i(".richFieldBannerImageWrapper {\n  margin-bottom: var(--gutter-m); }\n\n.richFieldBannerImageWrapper img {\n  display: inline-block;\n  width: 100%;\n  margin-bottom: var(--gutter-m); }\n");
i(":root{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:50%;width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next:after,.swiper-button-prev:after{font-family:swiper-icons;font-size:var(--swiper-navigation-size);text-transform:none!important;letter-spacing:0;font-variant:initial;line-height:1}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:10px;right:auto}.swiper-button-prev:after,.swiper-rtl .swiper-button-next:after{content:'prev'}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:10px;left:auto}.swiper-button-next:after,.swiper-rtl .swiper-button-prev:after{content:'next'}.swiper-button-lock{display:none}");
i(".swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:10px;left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:50%;background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:10px;top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:4px;height:100%;left:0;top:0}.swiper-pagination-lock{display:none}"), r.use([function ({
  swiper: a,
  extendParams: i,
  on: e,
  emit: n
}) {
  function t(i) {
    let e;
    return i && (e = l(i), a.params.uniqueNavElements && "string" == typeof i && e.length > 1 && 1 === a.$el.find(i).length && (e = a.$el.find(i))), e;
  }
  function s(i, e) {
    const n = a.params.navigation;
    i && i.length > 0 && (i[e ? "addClass" : "removeClass"](n.disabledClass), i[0] && "BUTTON" === i[0].tagName && (i[0].disabled = e), a.params.watchOverflow && a.enabled && i[a.isLocked ? "addClass" : "removeClass"](n.lockClass));
  }
  function r() {
    if (a.params.loop) return;
    const {
      $nextEl: i,
      $prevEl: e
    } = a.navigation;
    s(e, a.isBeginning && !a.params.rewind), s(i, a.isEnd && !a.params.rewind);
  }
  function o(i) {
    i.preventDefault(), (!a.isBeginning || a.params.loop || a.params.rewind) && (a.slidePrev(), n("navigationPrev"));
  }
  function p(i) {
    i.preventDefault(), (!a.isEnd || a.params.loop || a.params.rewind) && (a.slideNext(), n("navigationNext"));
  }
  function c() {
    const i = a.params.navigation;
    if (a.params.navigation = g(a, a.originalParams.navigation, a.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !i.nextEl && !i.prevEl) return;
    const e = t(i.nextEl),
      n = t(i.prevEl);
    e && e.length > 0 && e.on("click", p), n && n.length > 0 && n.on("click", o), Object.assign(a.navigation, {
      $nextEl: e,
      nextEl: e && e[0],
      $prevEl: n,
      prevEl: n && n[0]
    }), a.enabled || (e && e.addClass(i.lockClass), n && n.addClass(i.lockClass));
  }
  function d() {
    const {
      $nextEl: i,
      $prevEl: e
    } = a.navigation;
    i && i.length && (i.off("click", p), i.removeClass(a.params.navigation.disabledClass)), e && e.length && (e.off("click", o), e.removeClass(a.params.navigation.disabledClass));
  }
  i({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), a.navigation = {
    nextEl: null,
    $nextEl: null,
    prevEl: null,
    $prevEl: null
  }, e("init", () => {
    !1 === a.params.navigation.enabled ? u() : (c(), r());
  }), e("toEdge fromEdge lock unlock", () => {
    r();
  }), e("destroy", () => {
    d();
  }), e("enable disable", () => {
    const {
      $nextEl: i,
      $prevEl: e
    } = a.navigation;
    i && i[a.enabled ? "removeClass" : "addClass"](a.params.navigation.lockClass), e && e[a.enabled ? "removeClass" : "addClass"](a.params.navigation.lockClass);
  }), e("click", (i, e) => {
    const {
        $nextEl: t,
        $prevEl: s
      } = a.navigation,
      r = e.target;
    if (a.params.navigation.hideOnClick && !l(r).is(s) && !l(r).is(t)) {
      if (a.pagination && a.params.pagination && a.params.pagination.clickable && (a.pagination.el === r || a.pagination.el.contains(r))) return;
      let i;
      t ? i = t.hasClass(a.params.navigation.hiddenClass) : s && (i = s.hasClass(a.params.navigation.hiddenClass)), n(!0 === i ? "navigationShow" : "navigationHide"), t && t.toggleClass(a.params.navigation.hiddenClass), s && s.toggleClass(a.params.navigation.hiddenClass);
    }
  });
  const u = () => {
    a.$el.addClass(a.params.navigation.navigationDisabledClass), d();
  };
  Object.assign(a.navigation, {
    enable: () => {
      a.$el.removeClass(a.params.navigation.navigationDisabledClass), c(), r();
    },
    disable: u,
    update: r,
    init: c,
    destroy: d
  });
}, function ({
  swiper: a,
  extendParams: i,
  on: e,
  emit: n
}) {
  const t = "swiper-pagination";
  let s;
  i({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: a => a,
      formatFractionTotal: a => a,
      bulletClass: `${t}-bullet`,
      bulletActiveClass: `${t}-bullet-active`,
      modifierClass: `${t}-`,
      currentClass: `${t}-current`,
      totalClass: `${t}-total`,
      hiddenClass: `${t}-hidden`,
      progressbarFillClass: `${t}-progressbar-fill`,
      progressbarOppositeClass: `${t}-progressbar-opposite`,
      clickableClass: `${t}-clickable`,
      lockClass: `${t}-lock`,
      horizontalClass: `${t}-horizontal`,
      verticalClass: `${t}-vertical`,
      paginationDisabledClass: `${t}-disabled`
    }
  }), a.pagination = {
    el: null,
    $el: null,
    bullets: []
  };
  let r = 0;
  function o() {
    return !a.params.pagination.el || !a.pagination.el || !a.pagination.$el || 0 === a.pagination.$el.length;
  }
  function p(i, e) {
    const {
      bulletActiveClass: n
    } = a.params.pagination;
    i[e]().addClass(`${n}-${e}`)[e]().addClass(`${n}-${e}-${e}`);
  }
  function d() {
    const i = a.rtl,
      e = a.params.pagination;
    if (o()) return;
    const t = a.virtual && a.params.virtual.enabled ? a.virtual.slides.length : a.slides.length,
      g = a.pagination.$el;
    let d;
    const u = a.params.loop ? Math.ceil((t - 2 * a.loopedSlides) / a.params.slidesPerGroup) : a.snapGrid.length;
    if (a.params.loop ? (d = Math.ceil((a.activeIndex - a.loopedSlides) / a.params.slidesPerGroup), d > t - 1 - 2 * a.loopedSlides && (d -= t - 2 * a.loopedSlides), d > u - 1 && (d -= u), d < 0 && "bullets" !== a.params.paginationType && (d = u + d)) : d = void 0 !== a.snapIndex ? a.snapIndex : a.activeIndex || 0, "bullets" === e.type && a.pagination.bullets && a.pagination.bullets.length > 0) {
      const n = a.pagination.bullets;
      let t, o, c;
      if (e.dynamicBullets && (s = n.eq(0)[a.isHorizontal() ? "outerWidth" : "outerHeight"](!0), g.css(a.isHorizontal() ? "width" : "height", s * (e.dynamicMainBullets + 4) + "px"), e.dynamicMainBullets > 1 && void 0 !== a.previousIndex && (r += d - (a.previousIndex - a.loopedSlides || 0), r > e.dynamicMainBullets - 1 ? r = e.dynamicMainBullets - 1 : r < 0 && (r = 0)), t = Math.max(d - r, 0), o = t + (Math.min(n.length, e.dynamicMainBullets) - 1), c = (o + t) / 2), n.removeClass(["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(a => `${e.bulletActiveClass}${a}`).join(" ")), g.length > 1) n.each(a => {
        const i = l(a),
          n = i.index();
        n === d && i.addClass(e.bulletActiveClass), e.dynamicBullets && (n >= t && n <= o && i.addClass(`${e.bulletActiveClass}-main`), n === t && p(i, "prev"), n === o && p(i, "next"));
      });else {
        const i = n.eq(d),
          s = i.index();
        if (i.addClass(e.bulletActiveClass), e.dynamicBullets) {
          const i = n.eq(t),
            l = n.eq(o);
          for (let a = t; a <= o; a += 1) n.eq(a).addClass(`${e.bulletActiveClass}-main`);
          if (a.params.loop) {
            if (s >= n.length) {
              for (let a = e.dynamicMainBullets; a >= 0; a -= 1) n.eq(n.length - a).addClass(`${e.bulletActiveClass}-main`);
              n.eq(n.length - e.dynamicMainBullets - 1).addClass(`${e.bulletActiveClass}-prev`);
            } else p(i, "prev"), p(l, "next");
          } else p(i, "prev"), p(l, "next");
        }
      }
      if (e.dynamicBullets) {
        const t = Math.min(n.length, e.dynamicMainBullets + 4),
          l = (s * t - s) / 2 - c * s,
          r = i ? "right" : "left";
        n.css(a.isHorizontal() ? r : "top", `${l}px`);
      }
    }
    if ("fraction" === e.type && (g.find(c(e.currentClass)).text(e.formatFractionCurrent(d + 1)), g.find(c(e.totalClass)).text(e.formatFractionTotal(u))), "progressbar" === e.type) {
      let i;
      i = e.progressbarOpposite ? a.isHorizontal() ? "vertical" : "horizontal" : a.isHorizontal() ? "horizontal" : "vertical";
      const n = (d + 1) / u;
      let t = 1,
        s = 1;
      "horizontal" === i ? t = n : s = n, g.find(c(e.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${t}) scaleY(${s})`).transition(a.params.speed);
    }
    "custom" === e.type && e.renderCustom ? (g.html(e.renderCustom(a, d + 1, u)), n("paginationRender", g[0])) : n("paginationUpdate", g[0]), a.params.watchOverflow && a.enabled && g[a.isLocked ? "addClass" : "removeClass"](e.lockClass);
  }
  function u() {
    const i = a.params.pagination;
    if (o()) return;
    const e = a.virtual && a.params.virtual.enabled ? a.virtual.slides.length : a.slides.length,
      t = a.pagination.$el;
    let s = "";
    if ("bullets" === i.type) {
      let n = a.params.loop ? Math.ceil((e - 2 * a.loopedSlides) / a.params.slidesPerGroup) : a.snapGrid.length;
      a.params.freeMode && a.params.freeMode.enabled && !a.params.loop && n > e && (n = e);
      for (let e = 0; e < n; e += 1) i.renderBullet ? s += i.renderBullet.call(a, e, i.bulletClass) : s += `<${i.bulletElement} class="${i.bulletClass}"></${i.bulletElement}>`;
      t.html(s), a.pagination.bullets = t.find(c(i.bulletClass));
    }
    "fraction" === i.type && (s = i.renderFraction ? i.renderFraction.call(a, i.currentClass, i.totalClass) : `<span class="${i.currentClass}"></span> / <span class="${i.totalClass}"></span>`, t.html(s)), "progressbar" === i.type && (s = i.renderProgressbar ? i.renderProgressbar.call(a, i.progressbarFillClass) : `<span class="${i.progressbarFillClass}"></span>`, t.html(s)), "custom" !== i.type && n("paginationRender", a.pagination.$el[0]);
  }
  function m() {
    a.params.pagination = g(a, a.originalParams.pagination, a.params.pagination, {
      el: "swiper-pagination"
    });
    const i = a.params.pagination;
    if (!i.el) return;
    let e = l(i.el);
    0 !== e.length && (a.params.uniqueNavElements && "string" == typeof i.el && e.length > 1 && (e = a.$el.find(i.el), e.length > 1 && (e = e.filter(i => l(i).parents(".swiper")[0] === a.el))), "bullets" === i.type && i.clickable && e.addClass(i.clickableClass), e.addClass(i.modifierClass + i.type), e.addClass(a.isHorizontal() ? i.horizontalClass : i.verticalClass), "bullets" === i.type && i.dynamicBullets && (e.addClass(`${i.modifierClass}${i.type}-dynamic`), r = 0, i.dynamicMainBullets < 1 && (i.dynamicMainBullets = 1)), "progressbar" === i.type && i.progressbarOpposite && e.addClass(i.progressbarOppositeClass), i.clickable && e.on("click", c(i.bulletClass), function (i) {
      i.preventDefault();
      let e = l(this).index() * a.params.slidesPerGroup;
      a.params.loop && (e += a.loopedSlides), a.slideTo(e);
    }), Object.assign(a.pagination, {
      $el: e,
      el: e[0]
    }), a.enabled || e.addClass(i.lockClass));
  }
  function b() {
    const i = a.params.pagination;
    if (o()) return;
    const e = a.pagination.$el;
    e.removeClass(i.hiddenClass), e.removeClass(i.modifierClass + i.type), e.removeClass(a.isHorizontal() ? i.horizontalClass : i.verticalClass), a.pagination.bullets && a.pagination.bullets.removeClass && a.pagination.bullets.removeClass(i.bulletActiveClass), i.clickable && e.off("click", c(i.bulletClass));
  }
  e("init", () => {
    !1 === a.params.pagination.enabled ? w() : (m(), u(), d());
  }), e("activeIndexChange", () => {
    (a.params.loop || void 0 === a.snapIndex) && d();
  }), e("snapIndexChange", () => {
    a.params.loop || d();
  }), e("slidesLengthChange", () => {
    a.params.loop && (u(), d());
  }), e("snapGridLengthChange", () => {
    a.params.loop || (u(), d());
  }), e("destroy", () => {
    b();
  }), e("enable disable", () => {
    const {
      $el: i
    } = a.pagination;
    i && i[a.enabled ? "removeClass" : "addClass"](a.params.pagination.lockClass);
  }), e("lock unlock", () => {
    d();
  }), e("click", (i, e) => {
    const t = e.target,
      {
        $el: s
      } = a.pagination;
    if (a.params.pagination.el && a.params.pagination.hideOnClick && s && s.length > 0 && !l(t).hasClass(a.params.pagination.bulletClass)) {
      if (a.navigation && (a.navigation.nextEl && t === a.navigation.nextEl || a.navigation.prevEl && t === a.navigation.prevEl)) return;
      const i = s.hasClass(a.params.pagination.hiddenClass);
      n(!0 === i ? "paginationShow" : "paginationHide"), s.toggleClass(a.params.pagination.hiddenClass);
    }
  });
  const w = () => {
    a.$el.addClass(a.params.pagination.paginationDisabledClass), a.pagination.$el && a.pagination.$el.addClass(a.params.pagination.paginationDisabledClass), b();
  };
  Object.assign(a.pagination, {
    enable: () => {
      a.$el.removeClass(a.params.pagination.paginationDisabledClass), a.pagination.$el && a.pagination.$el.removeClass(a.params.pagination.paginationDisabledClass), m(), u(), d();
    },
    disable: w,
    render: u,
    update: d,
    init: m,
    destroy: b
  });
}]);
var d = function (i) {
    var s = i.section,
      l = i.style,
      r = void 0 === l ? {} : l,
      g = i.tracking,
      c = {
        img: r.img || {},
        wrapper: r.wrapper || {},
        srcSet: r.srcSet || "small",
        carouselView: r.carouselView || !1,
        carouselConfig: r.carouselConfig || {
          spaceBetween: 0,
          slidesPerView: 1,
          style: {},
          loop: !0,
          className: "",
          preloadImages: !0,
          pagination: {
            clickable: !0
          }
        }
      },
      d = function () {
        if (g) {
          var a = g.merchant,
            i = g.brand,
            n = g.trackerName;
          e.trackEvent(a, i, {
            trackingEventName: n
          });
        }
      };
    return s = n.srcSetRichFields(c.srcSet, s), a.createElement(a.Fragment, null, c.carouselView ? a.createElement(o, {
      spaceBetween: c.carouselConfig.spaceBetween,
      slidesPerView: c.carouselConfig.slidesPerView,
      loop: c.carouselConfig.loop,
      className: c.carouselConfig.className,
      style: c.carouselConfig.style,
      preloadImages: c.carouselConfig.preloadImages,
      navigation: !0,
      pagination: c.carouselConfig.pagination
    }, s.fields.map(function (i, e) {
      return i.cta_target = t.modifyHTTP(i.cta_target), i.image = t.modifyHTTP(i.image), a.createElement(p, {
        key: e
      }, a.createElement(u, {
        key: e,
        field: i,
        index: e,
        styleConfig: c,
        track: d
      }));
    })) : a.createElement("div", {
      className: "richFieldBannerImageWrapper",
      style: c.wrapper
    }, s.fields.map(function (i, e) {
      return i.cta_target = t.modifyHTTP(i.cta_target), i.image = t.modifyHTTP(i.image), a.createElement(u, {
        key: e,
        field: i,
        index: e,
        styleConfig: c,
        track: d
      });
    })));
  },
  u = function (i) {
    var e = i.field,
      n = i.styleConfig,
      t = i.track;
    return a.createElement(a.Fragment, null, e.cta_target ? a.createElement("a", {
      href: e.cta_target,
      target: "_blank",
      style: {
        cursor: "pointer",
        width: "100%"
      },
      onClick: t
    }, a.createElement("img", {
      loading: "lazy",
      src: e.image,
      style: n.img,
      alt: e.alt || "Illustration"
    })) : a.createElement("img", {
      loading: "lazy",
      src: e.image,
      style: n.img,
      alt: e.alt || "Illustration"
    }));
  };
export { d as default };